import React from 'react';

export interface SimpleBorderedCardProps {
  children: React.ReactNode;
  title: React.ReactNode;
}

const SimpleBorderedCard = (props: SimpleBorderedCardProps) => {
  return (
    <div className={'rounded-3xl p-2 pt-1 bg-primary-navyblue-shade h-full'}>
      <div className={'mb-1 min-h-[24px] flex items-center'}>{props.title}</div>
      <div
        className={
          'rounded-2xl bg-neutral-chalk p-4 text-primary-navyblue text-center h-[calc(100%-28px)]'
        }
      >
        <div className={'flex flex-col h-full'}>{props.children}</div>
      </div>
    </div>
  );
};

export default SimpleBorderedCard;
